import { Helmet } from "react-helmet-async";

const Canonical = ({
  canonicalUrl,
  title,
  hrfLang,
  description,
  schemeaOne,
  schemeaTwo,
  schemaThree,
  schemaFour,
  schemaFive,
  ogimage,
}) => (
  <Helmet>
    <link rel="canonical" href={canonicalUrl} />
    <title>{title}</title>
    <meta property="og:title" content={title} />
    <meta name="description" content={description} />
    <meta property="og:description" content={description} />
    <link rel="alternate" href={hrfLang} hreflang="en" />
    <script type="application/ld+json">{schemeaOne}</script>
    <script type="application/ld+json">{schemeaTwo}</script>
    <script type="application/ld+json">{schemaThree}</script>
    <script type="application/ld+json">{schemaFour}</script>
    <script type="application/ld+json">{schemaFive}</script>
    <meta property="og:image" content={ogimage} />
  </Helmet>
);

export default Canonical;
